export const CARDS_MAX_RESULTS = 1000;
// export const SHOPS_MAX_RESULTS = 2000;
// export const EVENTS_MAX_RESULTS = 900;
